import React from "react";
import styles from './styles';
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";
import {Box, Button, Container, withStyles} from "@material-ui/core";
import GenerateDialog from "../GenerateDialog";
import ReportForm from "../ReporForm";
import {getReport, requestReport} from "../../../stores/api";


@inject("reportStore", "deliveryStore","reportFormStore")
@observer
class Report extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      dateType: "",
      showDialog: false,
      pulling: false,
      loading: false,
      canDownload : true
    };

  }

  componentDidMount() {
    const { params } = this.props.match;
    const { reportStore } = this.props;
    const { reports } = reportStore;
    var report = reports.find(r=>r.type === params.id);
    if (report) {
        reportStore.setReport(report);
    }else {
      this.props.history.push(`/reports`);
    }
  }

  handleOpenDialog = () => {
    this.setState({showDialog: true}, this.generateReport)
  }

  handleCloseDialog = () => {
    this.setState({ showDialog: false })
  }

  generateReport = () => {
    const { reportFormStore, reportStore } = this.props;
    const request = {
      type: reportStore.report.type,
      report_params: reportFormStore.getData()
    };

    reportStore.setError("");
    requestReport(request).then(res => {
      if (res.ok) {
        const {id, status, url, count} = res.data;
        reportStore.setReportRequest({...request, id, status, url, count});
        this.fetchReport(id);
      } else {
        reportStore.setReportRequest({...request, status: "ERROR", url: null, count: null});
        reportStore.setError(res.originalError? `${res.originalError.message} ${res.originalError.stack}` : "Error while request report");
        console.log(res);
        reportStore.setPolling(false);
        this.handleCloseDialog()
      }

    });
  }


  fetchReport = (id) => {
    const { reportStore } = this.props;
    const { reportRequest } = reportStore;
    reportStore.setPolling(true);
    getReport(id).then(res => {

      if (res.ok) {

        const {status, url, count} = res.data;
        reportStore.setReportRequest({...reportRequest, id, status, url, count});
        if (!["ERROR", "UPLOAD_ERROR", "COMPLETED", "NO_ITEMS"].includes(status)) {
          reportStore.setPolling(false);
          setTimeout(() => {
            this.fetchReport(id);
          }, 5000);
        }
      } else {
        reportStore.setError(res.data ? res.data.message : "Error while requesting report");
        reportStore.setPolling(false);
      }
    })
  }

  downloadUrl = (id, e) => {
    if (e) e.preventDefault();
    window.open(`${import.meta.env.REACT_APP_API_ROOT}/reports/uploaded/${id}/download`, '_blank', 'noopener');
  }



  render() {
    const { reportStore } = this.props
    const { canDownload,showDialog,loading } = this.state;

    const { reportRequest, existingReports, sortOrder, report, error, polling } = reportStore;
    const {classes} = this.props;
    const theme = this.props.darkTheme ? "dark" : "light";
    const { regions } = reportRequest;


    return (
        <Container  className={classes.container}>
          <Box align="left" component="h2" className={classes.headerTitle}>{report?.title} Report</Box>
          { report?.inputParams &&
            <ReportForm
                type={report.type}
                inputParams={report.inputParams}
            />
          }

          <Box pt={3} pb={2} style={{textAlign: 'center'}}>
          <Button variant="contained" color="primary" onClick={this.handleOpenDialog} disabled={!canDownload || polling}>
            Generate
          </Button>
        </Box>
        {error && (
            <Box className={classes.redText} pt={1} align="center">{error}</Box>
        )}
        <GenerateDialog 
          showDialog = {showDialog}
          handleCloseDialog = {this.handleCloseDialog}
          classes = { classes }
          polling = { polling }
          loading = { loading}
          existingReports = { existingReports }
          generateReport = { this.generateReport }
          reportRequest = { reportRequest }
          error = { error }
          downloadUrl = { this.downloadUrl}
        />
        </Container>

    );
  }
}
export default withStyles(styles)(withRouter(Report));